import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "refetch"];
import { registerQuery, useQuery } from 'data-fetching-client';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { api } from '../utils/api';
import { TICKET_BASE_PATH } from '../../api/paths';
export const GET_TICKET_KEY = 'getTicket';
const getTicket = async variables => {
  const {
    id
  } = variables;
  const response = await api(`${TICKET_BASE_PATH}/${id}`);
  return response.json();
};
export const GET_TICKET = registerQuery({
  fieldName: GET_TICKET_KEY,
  args: ['id'],
  fetcher: getTicket
});
export const useTicket = id => {
  const _useQuery = useQuery(GET_TICKET, {
      variables: {
        id
      },
      skip: !id
    }),
    {
      data,
      loading,
      refetch
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  useRefetchOnWindowFocus({
    refetch,
    loading
  });
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data[GET_TICKET_KEY],
    refetch,
    loading
  }, rest);
};